import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/modules/user";
import { useAuthStore } from "@/stores/modules/auth";
// import { useGlobalStore } from "@/stores/modules/global";
import { LOGIN_URL, STATIC_ROUTER_WHITE_LIST, ROUTER_WHITE_LIST, HOME_URL, CodeWhitelist } from "@/config"; // HOME_URL,
import { initDynamicRouter } from "@/routers/modules/dynamicRouter";
import { staticRouter, errorRouter } from "@/routers/modules/staticRouter";
import NProgress from "@/config/nprogress";
import { getAuthqywxUrl, getqywxlogin, tokenLoginApi, getwxlogin, getAuthwxUrl } from "@/api/modules/weixin/index";
import { reactive, ref } from "vue";
import { localClear, removeQueryParameters } from "@/utils"; // getQueryVariable
import { getCookie, removeCookie } from "@/utils";
// import { useRenderDialog } from "@/hooks/useGetUserTelephone";

/**
 * @description 📚 路由参数配置简介
 * @param path ==> 路由菜单访问路径
 * @param name ==> 路由 name (对应页面组件 name, 可用作 KeepAlive 缓存标识 && 按钮权限筛选)
 * @param redirect ==> 路由重定向地址
 * @param component ==> 视图文件路径
 * @param meta ==> 路由菜单元信息
 * @param meta.icon ==> 菜单和面包屑对应的图标
 * @param meta.title ==> 路由标题 (用作 document.title || 菜单的名称)
 * @param meta.activeMenu ==> 当前路由为详情页时，需要高亮的菜单
 * @param meta.isLink ==> 路由外链时填写的访问地址
 * @param meta.isHide ==> 是否在菜单中隐藏 (通常列表详情页需要隐藏)
 * @param meta.isFull ==> 菜单是否全屏 (示例：数据大屏页面)
 * @param meta.isAffix ==> 菜单是否固定在标签页中 (首页通常是固定项)
 * @param meta.isKeepAlive ==> 当前路由是否缓存
 * */
// const sleep = (ms: number) => {
//   return new Promise(resolve => setTimeout(resolve, ms));
// };

const router = createRouter({
  history: createWebHistory(),
  routes: [...staticRouter, ...errorRouter],
  strict: false,
  scrollBehavior: () => ({ left: 0, top: 0 })
});

/**
 * 根据 userAgent 判断当前环境
 * @returns {string} - 返回环境标识：'wxwork'（企业微信）、'MicroMessenger'（个人微信）、'other'（其他环境）
 */
function getWeChatEnvironment() {
  if (navigator.userAgent.indexOf("wxwork") !== -1) {
    return "wxwork"; // 企业微信环境
  } else if (navigator.userAgent.indexOf("MicroMessenger") !== -1) {
    return "MicroMessenger"; // 个人微信环境
  } else {
    return "other"; // 其他环境
  }
}

// 判断访问视口
const getViewportWidth = () => {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

// const source_url = ref(null);
const cleanedPath = window.location.pathname.replace(/^[a-zA-Z0-9]+/, "");
const paramsToRemove = ["code", "state"];
let code = ref(null); // 拿到url中的code参数
const params = getViewportWidth() < 800 && getWeChatEnvironment() == "wxwork" ? { method: 4, platform: 1 } : null;
let platform = getViewportWidth() < 800 ? "qy_wechat" : "pc";
const client = import.meta.env.VITE_CLIENT;
// 企微/个微数据映射
const environmentConfig = reactive({
  wxwork: {
    getCodeData: {
      scope: "snsapi_privateinfo",
      redirect_uri: null,
      tab_name: "qywx_web_server_cloud"
    },
    loginData: {
      method: "qy_wechat_auth",
      platform,
      client,
      tab_name: "qywx_web_server_cloud"
    },
    loginApi: getqywxlogin,
    callBackApi: getAuthqywxUrl,
    backMenu: getViewportWidth() > 800 ? HOME_URL : "/designer_mobile"
  },
  MicroMessenger: {
    getCodeData: {
      scope: "snsapi_userinfo",
      redirect_uri: null,
      tab_name: "wx_web_server"
    },
    loginData: {
      method: "wechat_web_auth",
      platform,
      client,
      tab_name: "wx_web_server"
    },
    loginApi: getwxlogin,
    callBackApi: getAuthwxUrl,
    backMenu: "/designersettledIn"
  },
  other: {
    getCodeData: {
      redirect_uri: null
    },
    loginData: null,
    loginApi: null,
    callBackApi: null,
    backMenu: HOME_URL
  }
});

/**
 * @description 前置路由拦截 beforeEach
 * */
router.beforeEach(async (to, from, next) => {
  // await sleep(1000);
  // debugger;

  const userStore = useUserStore(); // 获取用户信息
  const authStore = useAuthStore(); // 获取菜单权限信息
  const cookieToken = getCookie("token");

  const clearUrlData = () => {
    code.value = null;
    to.query = {};
    to["href"] = removeQueryParameters(to["href"], paramsToRemove);
    to["fullPath"] = removeQueryParameters(to["fullPath"], paramsToRemove);
    environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri = removeQueryParameters(
      environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri,
      paramsToRemove
    );
  };

  const setUserInfo = async (data: any) => {
    // 将code等剩余无用参数清空
    clearUrlData();
    // 先清除缓存数据(用户数据)
    localClear();
    // userStore.clearuserdata();
    // 再将token缓存起来
    userStore.setToken(data.access_token);
    userStore.setTokenType(data.token_type);
    userStore.setRefreshToken(data.refresh_token);
    // 获取用户信息
    userStore.initUserInfo();
    await initDynamicRouter(params);
    return next(environmentConfig[getWeChatEnvironment()].backMenu);
  };

  if (environmentConfig[getWeChatEnvironment()] && !environmentConfig[getWeChatEnvironment()]!.getCodeData.redirect_uri)
    environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri = window.location.href;

  // 1.NProgress 开始
  NProgress.start();

  // 2.动态设置标题
  const title = import.meta.env.VITE_GLOB_APP_TITLE;
  document.title = to.meta.title ? `${to.meta.title} - ${title}` : title;

  if (cookieToken && !userStore.token && navigator.userAgent.indexOf("wxwork") !== -1) {
    tokenLoginFun(cookieToken).then(async (res: any) => {
      if (res.code == 200) {
        removeCookie("token", "");
        return next();
      }
    });
  }
  // 判断访问是否为静态路由/动态白名单/登录，如果是直接放行
  if (
    STATIC_ROUTER_WHITE_LIST.includes(to.path) ||
    ROUTER_WHITE_LIST.includes(to.path) ||
    (to.path.toLocaleLowerCase() === LOGIN_URL && getWeChatEnvironment() === "other")
  )
    return next();

  if (!code.value && getWeChatEnvironment() !== "other" && to.query.code) code.value = to.query.code;

  if (code.value && getWeChatEnvironment() !== "other" && !CodeWhitelist.includes(to.path)) {
    const { loginData, loginApi } = environmentConfig[getWeChatEnvironment()];
    const res = await loginApi({ code: code.value, ...loginData, user_code: to.query?.inviteCode });
    if (res.code === 200) return setUserInfo(res.data);
    else return next("/500");
  }

  // 获取路由
  if (!authStore.authMenuListGet.length) {
    try {
      await initDynamicRouter(params);
      // if (userStore.userInfo && userStore.userInfo.jobs.map(item => item.name).includes("未入职设计师")) alert("请先完善信息");
      if (to.path === "/") return next(environmentConfig[getWeChatEnvironment()].backMenu);
      return next({ ...to, replace: true });
    } catch (error) {
      return next("/500");
    }
  }

  if (!userStore.token || !authStore.getTokenStatus) {
    try {
      // 不是浏览器环境授权登录 微信/企微授权登录 浏览器跳转登录
      if (getWeChatEnvironment() !== "other") {
        const { getCodeData, callBackApi } = environmentConfig[getWeChatEnvironment()];
        const { data } = await callBackApi(getCodeData);
        return (window.location.href = data);
      } else return userStore.logout();
    } catch (error) {
      console.error(error);
      return next("/500");
    }
  }

  // 7.存储 routerName 做按钮权限筛选
  authStore.setRouteName(to.path as string);

  // 8.正常访问页面
  if (cleanedPath.startsWith("&") && getWeChatEnvironment() !== "other") {
    next(to.fullPath.replace("&", "?"));
  }
  next();
});

/**
 * @description 重置路由
 * */
export const resetRouter = () => {
  const authStore = useAuthStore();
  authStore.flatMenuListGet.forEach(route => {
    const { name } = route;
    if (name && router.hasRoute(name)) router.removeRoute(name);
  });
  if (getWeChatEnvironment() !== "other") environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri = null;
};

/**
 * @description 路由跳转错误
 * */
router.onError(error => {
  NProgress.done();
  if (getWeChatEnvironment() !== "other") environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri = null;
  const fetchResourcesErrors = ["Failed to fetch dynamically imported module", "Importing a module script failed"];
  if (fetchResourcesErrors.some(item => error?.message && error.message?.includes(item))) {
    window.location.reload();
  }
  console.warn("路由错误", error.message);
});

/**
 * @description 路由跳转结束
 * */
router.afterEach(() => {
  NProgress.done();
  if (getWeChatEnvironment() !== "other") environmentConfig[getWeChatEnvironment()].getCodeData.redirect_uri = null;
});

export const tokenLoginFun = async (token: string) => {
  return new Promise(async resolve => {
    try {
      const userStore = useUserStore();
      //userStore.setToken(token);
      const res = await tokenLoginApi({
        token: token,
        method: "token",
        platform: "pc",
        client: 68659434,
        target_system_token: userStore.token ? userStore.token : ""
      });
      if (res.code == 200) {
        if (!res.data.target_system_status) {
          userStore.setToken(res.data.access_token);
          userStore.setTokenType(res.data.token_type);
          userStore.setRefreshToken(res.data.refresh_token);
        }
        const infoRes = await userStore.initUserInfo();
        // 添加动态路由
        await initDynamicRouter();
        // 清空 tabs、keepAlive 数据
        //tabsStore.closeMultipleTab();
        //keepAliveStore.setKeepAliveName();
        resolve(infoRes);
      } else {
        resolve(false);
      }
    } catch (error) {
      resolve(false);
    }
  });
};

export default router;
